(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ww-pulse"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ww-pulse-diagram')) {
  customElements.define('ww-pulse-diagram', class extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('[data-ww-pulse-toggle]');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = false;
      this.visible = false;
      this.update = () => {
        const running = this.visible && !this.paused && !this.reduced.matches && !document.hidden;
        this.toggleAttribute('data-running', running);
        this.toggle.setAttribute('aria-pressed', String(this.paused));
        this.toggle.textContent = this.paused ? this.toggle.dataset.play : this.toggle.dataset.pause;
      };
      this.onToggle = () => { this.paused = !this.paused; this.update(); };
      this.toggle.addEventListener('click', this.onToggle);
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.update(); }, {threshold: .15});
      this.observer.observe(this);
      document.addEventListener('visibilitychange', this.update);
      this.reduced.addEventListener('change', this.update);
      this.update();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.toggle?.removeEventListener('click', this.onToggle);
      document.removeEventListener('visibilitychange', this.update);
      this.reduced?.removeEventListener('change', this.update);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
